import React, { useState } from 'react';
import './App.css';
import LandingPage from './Pages/LandingPage/LandingPage';
import LoadingWheel from './Components/LoadingWheel/LoadingWheel';
import AuthB2C from './Components/AuthB2C/AuthB2C';

function App(props) {
  const { organization, tiles } = props;
  const [authData, setAuthData] = useState('');

  const handleTokenChange = (token) => {
    setAuthData(token);
  };

  return (
    <div className="App">
      <AuthB2C handleTokenChange={handleTokenChange} />
      {authData === '' && <LoadingWheel />}
      {authData !== '' && <LandingPage organization={organization} tiles={tiles} />}
    </div>
  );
}

export default App;
